import { z } from "zod";
import { isoDate, trimmed, uuid } from "./schemas/common";

/**
 * Shared run sheets: a live, read-only link to the day's schedule for vendors and helpers, without an account
 * (Premium and above, on the wedding owner's plan). Rules live in ShareLinkService.
 */
export const SHARE = {
  /** Default lifetime: until a week after the wedding. */
  defaultDaysAfterWedding: 7,
  maxDaysAhead: 400,
  passcodeMin: 4,
  passcodeMax: 32,
} as const;

export const createShareLinkSchema = z.object({
  label: trimmed(80).default(""),
  /** Filter the sheet to one vendor's events and contact; null = the whole team's sheet. */
  vendorId: uuid.nullable().default(null),
  includeContacts: z.boolean().default(true),
  passcode: z.string().trim().min(SHARE.passcodeMin).max(SHARE.passcodeMax).nullable().default(null),
  expiresAt: isoDate.optional(),
});
export type CreateShareLink = z.infer<typeof createShareLinkSchema>;

export interface ShareLinkDTO {
  id: string; token: string; url: string; label: string; vendorId: string | null; vendorName: string | null;
  includeContacts: boolean; hasPasscode: boolean; expiresAt: string; revokedAt: string | null;
  viewCount: number; lastViewedAt: string | null; createdAt: string;
}

export interface RunSheetEventDTO { id: string; title: string; time: string; durationMinutes: number; location: string; notes: string; colorHex: string; vendorName: string | null }
/** Business contact details of a vendor, only what a run sheet needs — never prices, deposits, contracts or notes. */
export interface RunSheetContactDTO { id: string; type: string; name: string; contactName: string; phone: string; email: string }

export interface RunSheetDTO {
  coupleTitle: string; weddingDate: string; venueName: string; venueAddress: string; label: string;
  events: RunSheetEventDTO[];
  /** null when the link was made without contacts. */
  contacts: RunSheetContactDTO[] | null;
  generatedAt: string;
}
